<template>
  <div class="project-list-main">
    <el-dialog
    class="modal project-list"
    :title="DialogTitle"
    :visible="listVisible"
    :close-on-click-modal="false"
    @close="$emit('close', false)"
    width="1260px"
  >
    <div class="dialog-title" slot="title">
      <i class="iconfont icon-xiangmutubiao"></i>
      {{DialogTitle}}
    </div>
    <div>
      <span v-if="isShow" class="all_project">{{$t('showAll')}}</span>
      <el-switch
          v-if="isShow"
          v-model="isAll"
          active-color="#13ce66"
          @change="handleAllList"
          >
        </el-switch>
        <div class="key_input">
          <el-input v-model="keyWords" :placeholder="$t('porjectMsg')"></el-input>
        </div>
        <div class="block_pro">
          <!-- <el-date-picker
            v-model="valueTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            :range-separator="to"
            :start-placeholder="startDate"
            :end-placeholder="endDate">
          </el-date-picker> -->
            <el-date-picker
            v-model="startTime"
            type="date"
             value-format="yyyy-MM-dd"
            :placeholder="startDate">
          </el-date-picker>
          <span class="zhi">{{to}}</span>
            <el-date-picker
            v-model="endTime"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="endDate">
          </el-date-picker>
        </div>
         <el-button type="primary" class="btn_search" @click="handleSearch">{{$t('search')}}</el-button>
    </div>
    <div class="project-list-main">
      <Table
        :dataSource="dataSource"
        :columns="tableColumns"
        :height='600'
        ref="projectList"
      >
      <template #operate>
          <el-table-column
          :label="$t('operation')"
          class="table-operate"
          >
          <template slot-scope="scope">
            <div class="table-operate">
              <el-tooltip class="item" effect="dark" :content="$t('panelDetail')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-info pointer" @click="detailRow(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('delete')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-delete pointer" @click="delRow(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('edit')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-edit pointer" @click="editRow(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('copy')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-document-copy pointer" @click="copyRow(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('download')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-download  pointer" @click="downRow(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="$t('import')" :hide-after="2000" placement="top">
                <i class="iconfont el-icon-upload2 pointer" @click="importRow(scope.row)"></i>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </template>
      </Table>
      <Pagination
        v-if="dataSource.length > 0"
        :total="total"
        :pageSize="pageSize"
        :currentPage="pageNumber"
        @change="ajax_list_get"
        style="margin: 10px 5% 0;"
      />
    </div>
    <div class="project-list-button">
      
    </div>
    </el-dialog>
    <configNew type='edit' :DialogVisible='newDialog' :data='editData' @close='closeProjectEdit' :DialogTitle='editDialogTitle'></configNew>
    <configInfo v-if="infoDialog" :DialogVisible='infoDialog' @close='closeProjectinfo' :data='panelsData'></configInfo>
    <projectLead :hasProject='true' v-if="leadDialog" :DialogVisible='leadDialog' @close='closeProjecLead' :projectId='projectId'></projectLead>
  </div>
</template>
<script>
import {projectList, projectDelete, projectUpdate, projectCopy, projectInfo, projectDown} from '../../api/config'
import configNew from './configNew.vue'
import configInfo from './configInfo.vue'
import projectLead from './projectLeading'
import Cookies from 'js-cookie'
import config from '../../common/config'
export default {
  name: 'projectList',
  props:{
    listVisible: {
      type: Boolean,
      default: false
    },
    DialogTitle: {
      type: String,
      default: ''
    },
  },
  components:{
    configNew,
    configInfo,
    projectLead
  },
  data () {
    return {
      dataSource: [],
      tableColumns: [{
        prop: 'loginName',
        label: this.$t('userName'),
        showOverflowTooltip: true
      }, {
        prop: 'grantPermission',
        label: this.$t('applicationTime')
      }, {
        prop: 'site',
        label: this.$t('projectTablesite'),
        showOverflowTooltip: true
      }, {
        prop: 'panelCounts',
        label: this.$t('projectTablepanelsNumber')
      }, {
        prop: 'createdTime',
        label: this.$t('projectTablecreatedTime')
      }, {
        prop: 'lastModifiedTime',
        label: this.$t('projectTablemodifyTime')
      }, {
        prop: 'descr',
        label: this.$t('projectTablenotes')
      }, 
      {
        prop: 'panelType',
        label: this.$t('projectPanelMode'),
      },{
        prop: 'operate',
        label: this.$t('operation'),
        slotName: 'operate',
      }],
      get_data: {
        userId: Cookies.get(config.userId)
      },
      newDialog: false,
      editData: {},
      editDialogTitle: '',
      infoDialog: false,
      panelsData: '',
      leadDialog: false,
      projectId: '',
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      language: Cookies.get(config.language) || 'english',
      isShow: Cookies.get(config.role) / 1 === 3,
      isAll: false,
      to: this.$t('to'),
      startDate: this.$t('startDate'),
      endDate: this.$t('endDate'),
      valueTime: null,
      keyWords: '',
      startTime: null,
      endTime: null
    }
  },
  mounted () {
    this.$nextTick(()=>{
      this.ajax_list_get();
    })
    const start = this.getNowFormatDate(0)
    const end = this.getNowFormatDate(1)
    this.startTime = start
    this.endTime = end
    // if (!this.isShow) {
    //   this.tableColumns = this.tableColumns.slice(2, 8)
    // }
  },
  methods: {
    handleSearch () {
      this.ajax_list_get()
    },
    getNowFormatDate (value) {
      var date = new Date()
      var seperator1 = "-"
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (value === 0) {
        year = date.getFullYear() - 1
      } else if (value === 1) {
        year = date.getFullYear()
      }
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = "0" + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    },
    ajax_list_get (pageObj = { pageNum: 1, pageSize: this.pageSize }) {
      const page = {
        isPage: 1,
        pageNumber: pageObj.pageNum,
        pageSize: pageObj.pageSize,
        showAll: this.isAll ? 1 : 0,
        startTime: this.startTime ? this.startTime + ' ' + '00:00:00' : '',
        endTime: this.endTime ? this.endTime + ' ' + '23:59:59' : '',
        site: this.keyWords
      }
      projectList(Object.assign(this.get_data, page)).then(res => {
        if (res.code == 1) {
          this.dataSource = res.data
          this.dataSource.forEach(element => {
            element.createdTime = this.timestampToTime(element.created)
            element.lastModifiedTime = this.timestampToTime(element.lastModified)
            element.grantPermission = element.grantPermission ? this.timestampToTime(element.grantPermission) : ''
            element.panelType = element.panelType ? this.$t("projectPanelTypeNetwork") : this.$t("projectPanelTypeSingle")
          })
          this.total = res.total
          this.pageSize = res.pageSize
          this.pageNumber = res.pageNumber
          // this.$refs.projectList.doLayout()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    timestampToTime (timestamp) {
      let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + '-'
      let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      let h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      let m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    delRow (data) {
      this.$msgbox({
        title: this.$t('prompt'),
        message: this.$t('sureDelete'),
        showCancelButton: true,
        confirmButtonText: this.$t('sure'),
        cancelButtonText: this.$t('cancel'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            // instance.confirmButtonText = '执行中...'
            projectDelete({ id:data.id }).then(res => {
              if (res.code == 1) {
                instance.confirmButtonLoading = false
                this.$message.success(this.$t('projectTableDelete'))
                this.ajax_list_get()
              } else {
                instance.confirmButtonLoading = false
                this.$message.warning(res.msg)
              }
              done()
            }).catch(() => {
              instance.confirmButtonLoading = false
            })
          } else {
            done()
          }
        }
      }).then(action => {
      })
    },
    infoGet (id) {
      return new Promise((resolve, reject) => {
        projectInfo({ projectId:id }).then(res => {
          if (res.code == 1) {
            resolve(res.data)
          } else {
            reject(res.msg)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    deepClone (obj) {
      // 判断原对象是否存在
      if (obj) {
        var newObj = JSON.parse(JSON.stringify(obj))
        return newObj
      }
    },
    async editRow (data) {
      let aa = await this.infoGet(data.id)
      this.editData = this.deepClone(aa)
      this.editDialogTitle = this.$t('projectTableEdit')
      this.newDialog = true
    },
    closeProjectEdit () {
      this.newDialog = false
      this.ajax_list_get()
    },
    closeProjectinfo () {
      this.infoDialog = false
    },
    copyRow (data) {
      projectCopy({
        projectId:data.id,
        loadingText: this.$t('globalLoadingText')
      }).then(res => {
        if ( res.code == 1 ) {
          this.$message.success(this.$t('projectTableCopy'))
          this.ajax_list_get()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    async detailRow (data) {
      if (!data.panelCounts) {
        this.$message.warning(this.$t('projectTablePanelWarning'));
        return
      }
      let aa = await this.infoGet(data.id)
      if (aa.panels.length === 1) {
        let item = aa.panels[0]
        this.$router.push({ path: '/systemSettings', query: {
          projectName: aa.site,
          panelId: item.id,
          panelNo: item.panelNo,
          projectId: item.projectId
        }})
        this.$emit('close', false)
      } else {
        this.panelsData = aa.panels
        this.infoDialog = true
      }
    },
    downRow (data) {
      let params = {
        projectId: data.id,
        userId: Cookies.get(config.userId),
        lan: this.language
      }
      projectDown(params).then(res => {
        if (res.code == 1) {
          this.$message.success(this.$t('projectTableDown'))
        }
      }).catch(err => {
        console.log('ajax_err:', err)
      })
    },
    importRow (data) {
      this.projectId = data.id
      this.leadDialog = true
    },
    closeProjecLead () {
      this.leadDialog = false
    },
    // 查看所有项目
    handleAllList () {
      this.ajax_list_get()
    }
  },
  watch: {
    listVisible () {
      this.ajax_list_get()
    }
  }
}
</script>
<style lang="less" scoped>
.project-list{
    width: 100%;
    height: 100%;
    .project-list-main{
        width: 100%;
        .table-operate{
          width: 100%;
          display: flex;
          .iconfont{
            margin:0 3px;
          }
        }
    }
    .project-list-button{
        margin-top: 20px;
    }
    .all_project{
      margin: 0 5px 0 35px;
    }
    .block_pro{
      display: inline-block;
      margin-left: 10px;
      .zhi{
        line-height: 40px;
        margin: 0 5px 0 5px;
      }
    }
    .key_input{
      width: 180px;
      display: inline-block;
      margin-left: 10px;
    }
    .btn_search{
       width: 55px;
       padding: 10px 5px 10px 5px;
       margin-left: 10px;
    }
}
/deep/.el-input .el-input__inner {
    height: 40px;
}
</style>